const YesNoRenderer = (props) => {
  return props.value ? 'Yes' : 'No';
};

export default YesNoRenderer;
